import { render, staticRenderFns } from "./AdminCRM.vue?vue&type=template&id=3a3b045c&scoped=true"
import script from "./AdminCRM.vue?vue&type=script&lang=js"
export * from "./AdminCRM.vue?vue&type=script&lang=js"
import style0 from "./AdminCRM.vue?vue&type=style&index=0&id=3a3b045c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3b045c",
  null
  
)

export default component.exports